"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePartsOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const useOverlayComponents_1 = require("../../hooks/useOverlayComponents");
const focus_trap_react_1 = require("focus-trap-react");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
// eslint-disable-next-line max-lines-per-function
function MobilePartsOverlay({ name, parts, currentTab, isFullScreen, onToggleFullScreen, onCloseFullScreen, }) {
    const [selectedPart, setSelectedPart] = (0, react_1.useState)();
    const [selectedPartIndex, setSelectedPartIndex] = (0, react_1.useState)(parts.findIndex(spot => spot.isSelected) || 0);
    const [touchStartX, setTouchStartX] = (0, react_1.useState)(0);
    const [touchEndX, setTouchEndX] = (0, react_1.useState)(0);
    const bridge = (0, bridge_1.useBridge)();
    const theme = (0, styled_components_1.useTheme)();
    const isLoading = (0, models_1.useIsModelLoading)();
    const progress = (0, models_1.useDownloadingProgress)();
    const carouselRef = (0, react_1.useRef)(null);
    const closeRef = (0, react_1.useRef)(null);
    const modelContainer = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (closeRef.current) {
            closeRef.current.focus();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        const model = document.getElementById('model-container');
        if (!model)
            return;
        const originalParent = model.parentElement;
        (_a = modelContainer.current) === null || _a === void 0 ? void 0 : _a.appendChild(model);
        return () => {
            if (originalParent) {
                originalParent.appendChild(model);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const selectedIndex = parts.findIndex(spot => spot.isSelected);
        if (selectedIndex !== -1) {
            setSelectedPartIndex(selectedIndex);
            setSelectedPart(parts[selectedIndex]);
        }
    }, [parts]);
    const onSelect = (0, react_1.useCallback)((index) => {
        const spot = parts[index];
        setSelectedPartIndex(index);
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type: currentTab,
            index: spot.index,
            identifier: spot === null || spot === void 0 ? void 0 : spot.identifier,
        });
    }, [bridge, currentTab, parts]);
    const onTouchStart = (0, react_1.useCallback)((e) => {
        setTouchStartX(e.targetTouches[0].clientX); // Register where the touch starts
    }, []);
    const onTouchMove = (0, react_1.useCallback)((e) => {
        setTouchEndX(e.targetTouches[0].clientX); // Register where the touch moves
    }, []);
    const onTouchEnd = (0, react_1.useCallback)(() => {
        var _a, _b;
        const minRange = 50;
        if (touchEndX - touchStartX > minRange && selectedPartIndex > 0) {
            (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.select(selectedPartIndex - 1); // Swipe to the left
            onSelect(selectedPartIndex - 1);
        }
        if (touchStartX - touchEndX > minRange &&
            parts.length - 1 > selectedPartIndex) {
            (_b = carouselRef.current) === null || _b === void 0 ? void 0 : _b.select(selectedPartIndex + 1); // Swipe to the right
            onSelect(selectedPartIndex + 1);
        }
        setTouchStartX(0);
        setTouchEndX(0);
    }, [onSelect, parts.length, selectedPartIndex, touchEndX, touchStartX]);
    const { MotionControl, title } = (0, useOverlayComponents_1.useOverlayComponents)({
        tabType: currentTab,
        isFullScreen: !!isFullScreen,
    });
    return ((0, jsx_runtime_1.jsx)(focus_trap_react_1.FocusTrap, { focusTrapOptions: { allowOutsideClick: true }, "data-e2e": 'MobilePartsOverlay_FocusTrap', children: (0, jsx_runtime_1.jsxs)(Container, { role: "dialog", "data-e2e": 'MobilePartsOverlay_Container', children: [(0, jsx_runtime_1.jsx)(Header, { "data-e2e": 'MobilePartsOverlay_Header', children: (0, jsx_runtime_1.jsx)(ClasterName, { "data-e2e": 'MobilePartsOverlay_ClasterName', children: currentTab == bridge_schema_1.InfoBoxTabType.Isolate ? title : name }) }), (0, jsx_runtime_1.jsxs)(Display, { "$hasDescription": !!(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail), "data-e2e": 'MobilePartsOverlay_Display', children: [(0, jsx_runtime_1.jsx)(CloseButtonContainer, { "data-e2e": 'MobilePartsOverlay_CloseButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.CloseForGrasshopper, { onClick: onCloseFullScreen, tabIndex: 1, ref: closeRef, "data-e2e": 'MobilePartsOverlay_CloseForGrasshopper' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isFullScreen, timeout: 500, classNames: "fullscreen-transition", appear: true, "data-e2e": 'MobilePartsOverlay_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container3D, { id: "overlay-container-3d-model", "$isFullScreen": !!isFullScreen, "$hasDescription": !!(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail), ref: modelContainer, "data-e2e": 'MobilePartsOverlay_Container3D', children: [isLoading && ((0, jsx_runtime_1.jsx)(ProgressBarContainer, { "data-e2e": 'MobilePartsOverlay_ProgressBarContainer', children: (0, jsx_runtime_1.jsx)(ui_1.ProgressBar, { value: progress, backgroundColor: theme.grasshopper.modelBackground, "data-e2e": 'MobilePartsOverlay_ProgressBar' }) })), isLoading && ((0, jsx_runtime_1.jsx)(ProgressIndicatorContainer, { "data-e2e": 'MobilePartsOverlay_ProgressIndicatorContainer', children: (0, jsx_runtime_1.jsx)(ui_1.ProgressIndicator, { color: theme.grasshopper.loadingColor, "data-e2e": 'MobilePartsOverlay_ProgressIndicator' }) })), (0, jsx_runtime_1.jsxs)(ButtonsContainer, { "data-e2e": 'MobilePartsOverlay_ButtonsContainer', children: [(0, jsx_runtime_1.jsx)(ui_1.HideButton, { onClick: onToggleFullScreen, isSelected: !!isFullScreen, tabIndex: 2, "data-e2e": 'MobilePartsOverlay_HideButton' }), isFullScreen && ((0, jsx_runtime_1.jsx)(ui_1.CloseForGrasshopper, { onClick: onCloseFullScreen, "data-e2e": 'MobilePartsOverlay_CloseForGrasshopper' }))] }), MotionControl] }) }), !!parts.length && ((0, jsx_runtime_1.jsx)(ui_1.Carousel, { defaultSelected: selectedPartIndex, ref: carouselRef, onSelect: onSelect, "data-e2e": 'MobilePartsOverlay_Carousel', children: parts.map((part, i) => ((0, jsx_runtime_1.jsxs)(Description, { "data-e2e": 'MobilePartsOverlay_Description', children: [(0, jsx_runtime_1.jsxs)(TitleContainer, { "$hasDescription": !!(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail), "data-e2e": 'MobilePartsOverlay_TitleContainer', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'MobilePartsOverlay_Title', children: part.title }), part.subtitle && (0, jsx_runtime_1.jsxs)(Subtitle, { "data-e2e": 'MobilePartsOverlay_Subtitle', children: ["(", part.subtitle, ")"] })] }), (selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail) && part.detail && ((0, jsx_runtime_1.jsx)(TextContainer, { onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-e2e": 'MobilePartsOverlay_TextContainer', children: (0, jsx_runtime_1.jsx)(ui_1.InfoContainer, { descriptionText: selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail, "data-e2e": 'MobilePartsOverlay_InfoContainer' }) }))] }, i))) }, `carousel-${selectedPartIndex}`))] })] }) }));
}
exports.MobilePartsOverlay = MobilePartsOverlay;
const ProgressIndicatorContainer = styled_components_1.default.div `
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 12;
`;
const Description = styled_components_1.default.div `
  pointer-events: none;
`;
const ProgressBarContainer = styled_components_1.default.div `
  position: absolute;
  width: calc(100% - 8px);
  left: 4px;
  top: 0px;

  z-index: 12;
`;
const Container3D = styled_components_1.default.div `
  position: relative;
  width: 80vw;
  height: ${({ $hasDescription }) => ($hasDescription ? '25vh' : '65vh')};
  margin: 0;
  border-radius: 4px;
  background-color: black;

  z-index: 1;

  ${({ $isFullScreen }) => $isFullScreen &&
    (0, styled_components_1.css) `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      z-index: 9999 !important;
      margin: 0 !important;
    `}

  ${({ $hasDescription }) => !$hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.device.mobileS `
        margin: 0;
        height: 65vh;
        width: 100vw;
      `}
    `}

  ${ui_1.deviceLandscape.mobileS `
    margin: 0;
    height: 60vh;
    margin-right: 10px;
  `}

  ${({ $hasDescription }) => !$hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.deviceLandscape.mobileS `
        margin: 0;
        height: 45vh;
        margin-right: 10px;
      `}
    `}

  ${({ $hasDescription }) => !$hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.device.mobileM `
        margin: 0;
        width: 100vw;
        height: 76vh;
      `}
    `}

  ${ui_1.deviceLandscape.mobileM `
    margin: 24px;
    width: 85vw;
    height: 55vh;
  `}

  ${({ $hasDescription }) => !$hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.deviceLandscape.mobileL `
        margin: 0;
        width: 85vw;
        height: 45vh;
      `}
    `}

  ${ui_1.device.tablet `
    margin: 28px 0;
    width: 85vw;
    height: 42.5vh;
  `}

  ${ui_1.deviceLandscape.tablet `
    margin: 28px;
    width: 55vw;
    height: 60vh;
  `}

  ${({ $hasDescription }) => !$hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.device.tablet `
        margin: 28px 0;
        width: 85vw;
        height: 75vh;
      `}
    `}

  ${({ $hasDescription }) => !$hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.deviceLandscape.tablet `
        margin: 0;
        width: 85vw;
        height: 55vh;
      `}
    `}

  
  &.fullscreen-transition-enter,
  &.fullscreen-transition-exit {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
  }

  &.fullscreen-transition-enter {
    opacity: 0;
  }

  &.fullscreen-transition-enter-active {
    opacity: 1;
    transition: opacity 1200ms ease;
  }

  &.fullscreen-transition-exit {
    opacity: 1;
  }

  &.fullscreen-transition-exit-active {
    opacity: 0;
    transition: opacity 1200ms ease;
  }
`;
const ButtonsContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: row;
  top: 10px;
  right: 10px;
  gap: 10px;

  pointer-events: all;
`;
const Container = styled_components_1.default.div `
  color: ${({ theme }) => theme.white};
  height: calc(100vh - 50px);
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgroundSenary};
  border-radius: 8px 8px 0 0;

  & div[role='button'] {
    cursor: pointer;
  }

  &.enter,
  &.appear {
    transform: translateY(100vh);
  }

  &.enter-active,
  &.appear-active {
    transform: translateY(0);
    transition: transform 800ms ease;
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(120vh);
    transition: transform 800ms ease;
  }
`;
const TitleContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: 16px 0 8px;
  gap: 8px;
  align-items: center;

  ${({ $hasDescription }) => $hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.device.mobileL `
        margin: 16px;
      `}

      ${ui_1.deviceLandscape.mobileS `
        align-items: start;

        margin: 16px 8px 8px;
      `}
    `}
`;
const Title = styled_components_1.default.h2 `
  font-size: 24px;
  margin: 0;

  ${ui_1.device.mobileS `
    font-size: 20px;
    width: 75%;
    text-align: center; 
  `}

  ${ui_1.deviceLandscape.mobileM `
    font-size: 18px;
  `}
`;
const Subtitle = styled_components_1.default.p `
  margin: 0;
  font-size: 14px;

  ${ui_1.deviceLandscape.tablet `
    font-size: 18px;
  `}
`;
const TextContainer = styled_components_1.default.div `
  height: 30vh;
  display: flex;
  flex-direction: column;
  pointer-events: all;

  ${ui_1.device.mobileM `
    margin: 28px 0 0 8px;
    height: 48vh;
  `}

  ${ui_1.device.tablet `
    margin: 28px 0 0 8px;
    height: 30vh;
  `}

  ${ui_1.deviceLandscape.mobileL `
    margin: 28px 0 0 8px;
    height: 30vh;
  `}

  ${ui_1.deviceLandscape.tablet `
    height: 45vh;
    margin: 22px 8px 0 8px
  `}

  margin: 22px 0;

  & > :first-child {
    padding: 0;
  }
`;
const ClasterName = styled_components_1.default.h2 `
  font-size: 20px;
  margin-top: 10px;

  ${ui_1.device.mobileS `
    font-size: 18px;
  `}

  ${ui_1.deviceLandscape.mobileM `
    font-size: 16px;
  `}
`;
const Header = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 10px 0 0 2.5%;

  ${ui_1.deviceLandscape.mobileS `
    padding: 0 0 0 calc(36px + 8px);
  `}
`;
const Display = styled_components_1.default.div `
  flex-direction: column;
  flex: 1;
  padding: 0 2.5%;
  display: flex;
  align-items: center;

  & [class*='CarouselCard'] {
    padding: 0;
  }

  ${({ $hasDescription }) => $hasDescription &&
    (0, styled_components_1.css) `
      ${ui_1.deviceLandscape.mobileS `
        flex-direction: row-reverse;
        align-items: start;

        padding: 0;

        & [class*='CarouselCard'] {
          padding: 0 36px;
        }
      `}

      ${ui_1.deviceLandscape.laptopS `
        flex-direction: column;
        align-items: center;

        padding: 0 2.5%;

        & [class*='CarouselCard'] {
          padding: 0 0px;
        }
      `}
    `}
`;
const CloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  right: 10px;

  ${ui_1.deviceLandscape.tablet `
    top: 5px;
  `}
`;
